import CryptoJS from "crypto-js";
import {
  InvoiveAsDescribedBellow,
  otherArticleOptions,
  otherCost,
  vatFormats,
} from "./StringUtils";
import {
  HourlyWages,
  costAgreementArticle,
  costPerDayArticle,
  costPerMonthArticle,
  costPerWeekArticle,
} from "views/dashboard/economy/Articles";
import axios from "axios";
import { ARTICLE_NUMBERS, LOCALES, NEW_ARTICLES, VAT_TYPES } from "./constants";
import { schemaMarkupData } from "./schemaMarkup";
const cryptKey = import.meta.env.VITE_CRYPT_KEY ;

export function readCookie(cname) {
  var name = cname + "=";
  var decoded_cookie = decodeURIComponent(document.cookie);
  var carr = decoded_cookie.split(";");
  for (var i = 0; i < carr.length; i++) {
    var c = carr[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function checkUser() {
  // Retrieve user from local storage
  let user = JSON.parse(localStorage.getItem("user"));

  // Check if the user exists
  if (user) {
    return true;
  } else {
    return false;
  }
}

export function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

export const encryptPassword = (password) => {
  const encrypted = CryptoJS.AES.encrypt(password, cryptKey);
  return `${encrypted.toString()}`;
};

export const decryptPassword = (encryptedPassword) => {
  const decrypted = CryptoJS.AES.decrypt(encryptedPassword, cryptKey);
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const otherArticlesTotalAmount = (keyVal, otherArticlesData, self) => {
  let totalSum = 0;

  if (self) {
    const amount = Number(
      otherArticlesData?.find((obj) => obj.id === keyVal)?.value
    );

    if (amount !== 0) {
      return isNaN(amount) ? null : amount;
    } else {
      return null;
    }
  }

  const processArticle = (article, index) => {
    if (article && Array.isArray(article)) {
      article.forEach((item) => {
        if (item.key === keyVal) {
          totalSum += parseFloat(item.value, 10) || 0;
        }
      });
    }
  };

  for (const index in otherArticlesData) {
    const article = otherArticlesData[index];
    processArticle(article);
  }

  return totalSum;
};

export const getOtherArticlesUnit = (item, isLabel) => {
  switch (isLabel) {
    case "unit":
      return item?.key === "mileage"
        ? "Km"
        : item?.key === "allowance_out" || item?.key === "allowance_in"
        ? "Day"
        : "Pc";

    default:
      return "";
  }
};

export const getArticleIndividualAmount = (key, showInInvoiceKey, userOtherArticles) => {
  return userOtherArticles
    .filter(
      (article) =>
        article.key === key &&
       (article?.data[showInInvoiceKey] === "1" || article?.data?.isArticleShownInInvoice === true)
    )
    .reduce(
      (total, article) => total + Number(article?.valueInSelectedCurrency),
      0
    );
};

export const isArticleTaxFree = (item) => {
  const taxFreeConditions = {
    mileage: "isMileageReportTaxFree",
    allowance_out: "isAllowanceOutSTaxFree",
    allowance_in: "isAllowanceInSTaxFree",
    travel: "isTravelExpenseTaxFree",
    material_vat:"isMaterialExpenseTaxFree",
  };

  return (item?.data?.[taxFreeConditions[item?.key]] === "1" || item?.data?.isTaxFreeArticle);
};

export const diffInDats = (
  key,
  tripEndedDateIs,
  tripStartedDateIs,
  tripEndedDateOs,
  tripStartedDateOs
) => {
  let diffInMilliseconds;
  if (key === "allowance_in") {
    diffInMilliseconds =
      new Date(tripEndedDateIs) - new Date(tripStartedDateIs);
  } else {
    diffInMilliseconds =
      new Date(tripEndedDateOs) - new Date(tripStartedDateOs);
  }
  const diff = diffInMilliseconds / (1000 * 60 * 60 * 24);

  // Return 1 if the difference is 0 or greater
  return diff >= 0 ? Math.max(1, diff + 1) : 0;
};

export const calculateTotalSum = (data) => {
  let totalSum = 0;

  for (let key in data) {
    if (Array.isArray(data[key])) {
      data[key].forEach((item) => {
        const conditionsMet =
          item.data.isMileageArticleShowInInvoice !== "0" &&
          item.data.isArticleShowInInvoiceOS !== "0" &&
          item.data.isArticleShowInInvoiceIS !== "0" &&
          item.data.isTravelArticleShowInInvoice !== "0" &&
          item.data.isMaterialArticleShowInInvoice !== "0";

        if (conditionsMet) {
          totalSum += Number(item?.valueInSelectedCurrency)  || 0;
        }
      });
    }
  }

  return totalSum?.toFixed(2);
};

export const calculateExpenditureSum = (data) => {
  let totalSum = 0;

  for (let key in data) {
    if (Array.isArray(data[key])) {
      data[key].forEach((item) => {
        if (
          item.key === "material_vat" &&
          item.data.isMaterialExpenseTaxFree === "1"
        ) {
          totalSum += parseFloat(item.value) || 0;
        }
      });
    }
  }

  return totalSum?.toFixed(2);
};

export const convertHouseworkType = (houseworkType) => {
  switch (houseworkType) {
    case "CONSTRUCTION":
      return "Build";
    case "ELECTRICITY":
      return "Electricity";
    case "GLASSMETALWORK":
      return "Glass/sheet metal work";
    case "GROUNDDRAINAGEWORK":
      return "Soil/drainage work";
    case "MASONRY":
      return "Masonry";
    case "PAINTINGWALLPAPERING":
      return "Painting/wallpapering";
    case "HVAC":
      return "Plumbing";
    case "OTHERCOSTS":
      return "Other costs";
    case "CLEANING":
      return "Cleaning";
    case "TEXTILECLOTHING":
      return "Clothing and textile care";
    case "SNOWPLOWING":
      return "Snow shoveling";
    case "GARDENING":
      return "Gardening";
    case "BABYSITTING":
      return "Child care";
    case "OTHERCARE":
      return "Personal care";
    case "MOVINGSERVICES":
      return "Removal services";
    case "ITSERVICES":
      return "IT services";
    case "MAJORAPPLIANCEREPAIR":
      return "Repair of white goods";
    case "FURNISHING":
      return "Furnishings";
    case "HOMEMAINTENANCE":
      return "Supervision of housing";
    case "TRANSPORTATIONSERVICES":
      return "Transport services";
    case "WASHINGANDCAREOFCLOTHING":
      return "Washing and care of clothes";
    default:
      return "";
  }
};

export const formatDate = (prefillDate, paymentTerm, language) => {
  var currentDate = prefillDate ? new Date(prefillDate) : new Date();
  if (paymentTerm) {
    currentDate.setDate(currentDate.getDate() + Number(paymentTerm));
  }

  let lang;
  language === LOCALES.SV_SE ? (lang = LOCALES.SV_SE) : (lang = LOCALES.EN_US);  

  var options = { day: "numeric", month: "long", year: "numeric" };
  var formattedDate = currentDate.toLocaleString(lang, options);

  return formattedDate;
};

export const getArticleName = (number) => {
  switch (number) {
    case ARTICLE_NUMBERS.MILEAGE_TAX_FREE:
    case ARTICLE_NUMBERS.MILEAGE_WITH_TAX:
      return "Mileage Report";

    case ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE:
    case ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX:
      return "Allowance outside Sweden";

    case ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY:
    case ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY:
    case ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY:
    case ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY:
      return "Allowance in Sweden";

    case ARTICLE_NUMBERS.TRAVEL:
      return "Travel Expenses as per attached PDF";

    case ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE:
    case ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX:
      return "Expenses for materials and tools as per attached PDF";
    
    case ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX_WITHOUT_PDF:
      return "Expenses for materials and tools";

    case "92":
      return HourlyWages.description;

    case "94":
      return costPerDayArticle.description;

    case "95":
      return costPerWeekArticle.description;

    case "96":
      return costPerMonthArticle.description;

    case "97":
      return costAgreementArticle.description;

    default:
      return "Unknown Article";
  }
};

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "July",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const dataTable = (initialData) => {
  const prefillData = [];
  months.forEach((month) => {
    const monthData = initialData?.find((item) => item.month === month);
    if (monthData) {
      prefillData.push(monthData);
    } else {
      prefillData.push({
        month,
        hoursworked: "",
        absence: "",
        overtime: "",
        mertidFillingTime: "",
      });
    }
  });
  return prefillData;
};

export const validateFields = (fields) => {
  const errors = [];
  for (const key in fields) {
    if (fields.hasOwnProperty(key)) {
      const value = fields[key];
      if (typeof value === "string" && value.length < 3) {
        errors.push(`${key} must be at least 3 characters long.`);
      }
    }
  }
  return errors;
};

export const getArticleNumber = (item) => {
  if (!item?.key) return;

const fileName = item.data?.uploadFile?.[0]?.name || item.data?.fileName || null;

  switch (item.key) {
    case NEW_ARTICLES.MILEAGE:
      return (item?.data?.isMileageReportTaxFree === "1" || item?.data?.isTaxFreeArticle === true) ? ARTICLE_NUMBERS.MILEAGE_TAX_FREE : ARTICLE_NUMBERS.MILEAGE_WITH_TAX;

    case NEW_ARTICLES.ALLOWANCE_OUT:
      return (item?.data?.isAllowanceOutSTaxFree === "1" || item?.data?.isTaxFreeArticle === true) ? ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE : ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX;

    case NEW_ARTICLES.ALLOWANCE_IN:
      if (item?.data?.isAllowanceInSTaxFree === "1" || item?.data?.isTaxFreeArticle === true)  {
        return (item?.data?.isHalfDay ? (item?.data?.isHalfDay === "1" ? ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY : ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY) : item?.data?.articleNumber);
      } else {
        return (item?.data?.isHalfDay ? (item?.data?.isHalfDay === "1" ? ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY : ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY) : item?.data?.articleNumber);
      }

    case NEW_ARTICLES.TRAVEL:
      return ARTICLE_NUMBERS.TRAVEL;

    case NEW_ARTICLES.MATERIAL_VAT:
      return (item?.data?.isMaterialExpenseTaxFree === "1" || item?.data?.isTaxFreeArticle === true ) ? ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE : (fileName === null)
      ? ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX_WITHOUT_PDF
      : ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX;

    default:
      return;
  }
};

const translations = {
  [LOCALES.EN_US]: {
    paymentPerHour: "Payment Per Hour",
    paymentPerDay: "Payment Per Day",
    paymentPerWeek: "Payment Per Week",
    paymentPerMonth: "Payment Per Month",
    paymentPerAgreed: "Payment as Agreed",
    otherCostFirstLabel: "Other costs (travel and allowances)",
    otherCostSecondLabel: "Expenditure according to the attached pdf",
  },
  [LOCALES.SV_SE]: {
    paymentPerHour: "Betalning per timme",
    paymentPerDay: "Betalning per dag",
    paymentPerWeek: "Betalning per vecka",
    paymentPerMonth: "Betalning per månad",
    paymentPerAgreed: "Betalning enligt överenskommelse",
    otherCostFirstLabel: "Övriga kostnader (resa och traktamente)",
    otherCostSecondLabel: "Utlägg enligt bifogad pdf",
  },
};

const reverseTranslations = {
  [LOCALES.SV_SE]: Object.fromEntries(
    Object.entries(translations[LOCALES.SV_SE]).map(([key, value]) => [value, key])
  ),
  [LOCALES.EN_US]: Object.fromEntries(
    Object.entries(translations[LOCALES.EN_US]).map(([key, value]) => [value, key])
  ),
};

export const translate = (description, selectedLanguage) => {
  const currentLang = selectedLanguage === LOCALES.EN_US ? LOCALES.SV_SE : LOCALES.EN_US;
  if (!reverseTranslations[currentLang]) {
    return description;
  }
  const englishKey = reverseTranslations[currentLang][description];
  if (!englishKey) {
    return description;
  }
  const translation = translations[selectedLanguage][englishKey];
  if (!translation) {
    return description;
  }
  return translation;
};

export const translationsNewArticles = {
  "Mileage Report": "körjournal",
  "Travel Expenses as per attached PDF": "resekostnader enligt bifogad pdf",
  "Expenses for materials and tools as per attached PDF": "utgifter för material och verktyg enligt bifogad pdf",
  "Expenses for materials and tools": "utgifter för material och verktyg",
  "Allowance outside Sweden": "traktamente utanför sverige",
  "Allowance in Sweden": "traktamente i sverige"
};

export const translateArticle = (description, selectedLanguage) => {
  if (!selectedLanguage || selectedLanguage === LOCALES.SV_SE) {
    return translationsNewArticles[description] || description;
  }
  return description;
};

export const mobileScroll = () => {
  const isEconomy =
    window.location.pathname.includes("economy") ||
    window.location.pathname.includes("ekonomi");

  if (window.innerWidth < 769) {
    window.scrollTo({
      top: isEconomy ? 1050 : 550,
      left: 0,
      behavior: "smooth",
    });
  } else {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }
};

export const getViewInvoices = async (invoiceNumber) => {
  const res = await axios.get(`invoice/${invoiceNumber}`);
  if (res?.status === 200) {
    return res;
  }
};

export const getMonthDates = (currentDate) => {
  const firstDateOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  firstDateOfMonth.setDate(firstDateOfMonth.getDate() + 1);

  // Format the dates
  const formattedFirstDate = firstDateOfMonth.toISOString().split("T")[0];

  return {
    formattedFirstDate,
  };
};

export const getEndOfThirdMonth = (inputDate) => {
  const date = new Date(inputDate);

  // last date third month
  let endOfThirdMonth = new Date(date.getFullYear(), date.getMonth() + 3, 1);

  endOfThirdMonth.setDate(endOfThirdMonth.getDate());

  const formattedEndDate = endOfThirdMonth.toISOString().split("T")[0];

  return formattedEndDate;
};

export const getMonthName = (monthYear) => {
  const [year, month] = monthYear.split("-");
  const date = new Date(year, month - 1);
  return date.toLocaleString("default", { month: "long", year: "numeric" });
};
export const monthsOfYear = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

export const validateVatNumber = (countryCode, vatNumber) => {
  const format = vatFormats[countryCode];
  if (!format) return true;

  const { regex, minLength, maxLength } = format;
  if (!regex.test(vatNumber)) {
    if (minLength && maxLength) {
      return `Invalid VAT number format. It should be between ${minLength} and ${maxLength} digits long.`;
    }
    return `Invalid VAT number format. It should be ${maxLength} digits long.`;
  }
  return true;
};

export const tourSteps = (updateTourStatus, t) => {
  const stepsArray = [
    {
      selector: "#step1",
      content: ({ goTo, close }) => (
        <div>
          <p className="mb-2">
            {t(
              "To create an invoice, please navigate to this section and fill in the required details according to the invoice specifications."
            )}
          </p>

          <button
            onClick={() => {
              close();
              updateTourStatus();
            }}
            aria-label="Close Tour"
            className="tour-button"
          >
            {t("Skip")}
          </button>
          <button
            onClick={() => goTo(1)}
            data-step="1"
            aria-label="Go to Step 2"
            className="tour-button"
          >
            {t("Next")}
          </button>
        </div>
      ),
    },
    {
      selector: "#step2",
      content: ({ goTo }) => (
        <div>
          <p className="mb-2">
            {t(
              "Before creating the final invoice, you can use the timesheet feature to generate an invoice that can be saved for future reference or edited as needed. This feature is especially useful for tracking hours and ensuring all details are accurate before finalizing the invoice."
            )}
          </p>

          <button
            onClick={() => goTo(0)}
            data-step="0"
            aria-label="Go to Step 1"
            className="tour-button"
          >
            {t("Previous")}
          </button>
          <button
            onClick={() => goTo(2)}
            data-step="1"
            aria-label="Go to Step 2"
            className="tour-button"
          >
            {t("Next")}
          </button>
        </div>
      ),
    },
    {
      selector: "#step3",
      content: ({ goTo }) => (
        <div>
          <p className="mb-2">
            {t(
              "Here, You can access various sections related to your information, including invoices, customers, freelancers, timesheets, preliminary invoices, and more. These features provide comprehensive tools for managing and reviewing all aspects of your data."
            )}
          </p>

          <button
            onClick={() => goTo(1)}
            data-step="0"
            aria-label="Go to Step 1"
            className="tour-button"
          >
            {t("Previous")}
          </button>
          <button
            onClick={() => goTo(3)}
            data-step="1"
            aria-label="Go to Step 2"
            className="tour-button"
          >
            {t("Next")}
          </button>
        </div>
      ),
    },
    {
      selector: "#step4",
      content: ({ goTo }) => (
        <div>
          <p className="mb-2">
            {t(
              "If you want to review or access some of your personal or account information, you can do so in this tab."
            )}
          </p>
          <button
            onClick={() => goTo(2)}
            data-step="0"
            aria-label="Go to Step 1"
            className="tour-button"
          >
            {t("Previous")}
          </button>
          <button
            onClick={() => goTo(4)}
            data-step="1"
            aria-label="Go to Step 2"
            className="tour-button"
          >
            {t("Next")}
          </button>
        </div>
      ),
    },
    {
      selector: "#step5",
      content: ({ goTo }) => (
        <div>
          <p className="mb-2">
            {t(
              "This section pertains to your bank information. Providing accurate and up-to-date bank details is essential for the effective creation of invoices. Without these critical details, invoice generation cannot proceed. Please ensure your bank information is correctly entered to facilitate smooth financial operations."
            )}
          </p>

          <button
            onClick={() => goTo(3)}
            data-step="0"
            aria-label="Go to Step 1"
            className="tour-button"
          >
            {t("Previous")}
          </button>
          <button
            onClick={() => goTo(5)}
            data-step="1"
            aria-label="Go to Step 2"
            className="tour-button"
          >
            {t("Next")}
          </button>
        </div>
      ),
    },
    {
      selector: "#step6",
      content: ({ goTo }) => (
        <div>
          <p className="mb-2">
            {t(
              "To explore the features of our platform, you can navigate to this tab. It provides an overview of all available functionalities and tools."
            )}
          </p>

          <button
            onClick={() => goTo(4)}
            data-step="0"
            aria-label="Go to Step 1"
            className="tour-button"
          >
            {t("Previous")}
          </button>
          <button
            onClick={() => goTo(6)}
            data-step="1"
            aria-label="Go to Step 2"
            className="tour-button"
          >
            {t("Next")}
          </button>
        </div>
      ),
    },
    {
      selector: "#step7",
      content: ({ goTo }) => (
        <div>
          <p className="mb-2">
            {t(
              "If you need to perform calculations based on the amount, you can review details such as the invoice amount, VAT, and net salary. These examples will help you understand how different components affect the total calculations."
            )}
          </p>

          <button
            onClick={() => goTo(5)}
            data-step="0"
            aria-label="Go to Step 1"
            className="tour-button"
          >
            {t("Previous")}
          </button>
          <button
            onClick={() => goTo(7)}
            data-step="1"
            aria-label="Go to Step 2"
            className="tour-button"
          >
            {t("Next")}
          </button>
        </div>
      ),
    },
    {
      selector: "#step8",
      content: ({ goTo, close }) => (
        <div>
          <p className="mb-2">
            {t(
              "If you have any questions or need further clarification, please refer to our FAQ section. It's designed to address common queries and provide detailed answers to help you navigate our services more effectively."
            )}
          </p>
          <button
            onClick={() => goTo(6)}
            data-step="0"
            aria-label="Go to Step 1"
            className="tour-button"
          >
            {t("Previous")}
          </button>
          <button
            onClick={() => {
              close();
              updateTourStatus();
            }}
            aria-label="Close Tour"
            className="tour-button"
          >
            {t("Done")}
          </button>
        </div>
      ),
    },
  ];

  return stepsArray;
};

export const timeToDecimal = (time) => {
  if (typeof time === "number") {
    time = time.toString();
  }
  if (typeof time !== "string") {
    return "";
  }
  let [hours, minutes] = time.split(".").map(Number);
  if (isNaN(minutes)) {
    minutes = 0;
  } else if (minutes >= 60) {
    minutes = minutes / 100;
  }
  if (isNaN(hours)) {
    return "";
  }
  let decimalMinutes = minutes / 60;
  let totalHours = hours + decimalMinutes;
  return (Math.round(totalHours * 100) / 100)?.toFixed(2);
};

export const normalizeValues = (values, key) => {
  return values[key].replace(/[^a-zA-Z0-9]/g, "");
};

export const formatDateStr = (date, id) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  if (id) {
    return `${year}-${month}-${day}-${id}`;
  } else {
    return `${year}-${month}-${day}`;
  }
};

export function compareInvoicesHours(initialInvoiceHours, invoiceHours) {
  if (initialInvoiceHours.length !== invoiceHours.length) {
    return false;
  }

  for (let i = 0; i < initialInvoiceHours.length; i++) {
    const originalIndexKeys = Object.keys(initialInvoiceHours[i]);
    const invoiceIndexKeys = Object.keys(invoiceHours[i]);

    if (originalIndexKeys.length !== invoiceIndexKeys.length) {
      return false;
    }

    for (let key of originalIndexKeys) {
      if (!invoiceIndexKeys.includes(key)) {
        return false;
      }
    }
  }

  return true;
}

export const formatAmount = (amount) => {
  return typeof amount === "number" ? amount?.toFixed(2) : "0.00";
};

export const getSeparatedUserCalculationsTotal = (calculation) => {
  return calculation.reduce((total, current) => {
    Object.keys(current || {}).forEach((key) => {
      if (key !== "workingHours") {
        if (!total[key]) {
          total[key] = 0;
        }
        const directAssignKeys = new Set([
          "pensionPercentage",
          "vatPercentage",
          "pensionFeePer",
          "socialFeeRateDeduction",
          "fakturaFeePercentage",
          "taxRateDeduction"
        ]);
        total[key] = directAssignKeys.has(key) ? (current[key] || 0) : (total[key] + (current[key] || 0));
      }
    });
    return total;
  }, {});
};

export const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (reader.result) {
        const base64Data = reader.result?.split(",")[1];
        resolve(base64Data);
      } else {
        reject(new Error('Failed to read file content.'));
      }
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
}

export const calculateTotalWithVAT = (total, vat) => {
  if (!total || isNaN(total)) {
    return 0;
  }
  const vatAmount = vat ? total * (vat / 100) : 0;
  return total + vatAmount;
}

export const calculateTotalFileSize = (files) => {
  return files.reduce((total, file) => {
    if (file.fileContent) {
      //getting original byte size from base 64 string
      const fileSize = (file.fileContent.length * 3) / 4 - (file.fileContent.endsWith('==') ? 2 : file.fileContent.endsWith('=') ? 1 : 0);
      return total + fileSize;
    }

    return total;
  }, 0);
};

export const calculateAmountInSelectedCurrency = (item, currencyGlobalValue) => {
  const isMileage = item.key === NEW_ARTICLES.MILEAGE;
  const isAllowance = item.key === NEW_ARTICLES.ALLOWANCE_OUT || item.key === NEW_ARTICLES.ALLOWANCE_IN;

  // Determine the number based on the item type
  const number = isMileage
    ? item?.data?.distance
    : isAllowance
    ? diffInDats(
        item?.key,
        item?.data?.tripEndedDateIs || item?.data?.tripEndedDate,
        item?.data?.tripStartedDateIs || item?.data?.tripStartedDate,
        item?.data?.tripEndedDateOs || item?.data?.tripEndedDate,
        item?.data?.tripStartedDateOs || item?.data?.tripStartedDate
      )
    : "1";
  // Helper function to parse values
  const parseValue = (value, defaultValue = 0) => (isNaN(parseFloat(value)) ? defaultValue : Number(value));

  const currencyFactor = parseValue(currencyGlobalValue, 1);
  let amountPerUnit = 0;

  // Determine the amount per unit based on the item type
  if (isMileage) {
    amountPerUnit = 2.5 / currencyFactor;
  } else if (isAllowance) {
    const allowancePerDay = item?.data?.allowancePerDay || item?.data?.amountPerUnitSek ;
    amountPerUnit = parseValue(allowancePerDay) / currencyFactor;
  } else {
    amountPerUnit = (isNaN(parseFloat(item?.value)) ? 0 : Number(item?.value)) / currencyFactor;
  }
  // Calculate the total amount in the selected currency
  const amountInSelectedCurrency = Number(amountPerUnit?.toFixed(2)) * Number(number);


  return amountInSelectedCurrency?.toFixed(2);
}
export const getVatToShow = (customerVatType, vat) => {
  const reverseVatApplicable = [VAT_TYPES.SE_REVERSED_VAT, VAT_TYPES.EU_REVERSED_VAT, VAT_TYPES.EXPORT].includes(customerVatType);
  const vatToShow = reverseVatApplicable ? 0 : vat;
  return vatToShow;
};

export const vatPlaceholder = (countryCode) => {
  const vatPlaceholder = vatFormats[countryCode]?.vatPlaceholder || "Vat. Number";
  return vatPlaceholder;
};

export const getSchemaMarkup = (page) => {
  return schemaMarkupData[page] || null;
};
